import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { IMyDateModel, IMyDpOptions, IMyInputFieldChanged } from "mydatepicker";
import { ToastrModule, ToastrService } from "ngx-toastr";
import { element } from "protractor";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GlobalComponent } from "src/app/global/global.component";
import { IsViewEditpayrate, EmployeePayrateBO, functionpermission } from "../employee.model";
import { EmployeeService } from "../employee.service";
import { FormControl, Validators } from "@angular/forms";

@Component({
  selector: "app-pay-rates-edit",
  templateUrl: "./pay-rates-edit.component.html",
  styleUrls: ["./pay-rates-edit.component.scss"],
})
export class PayRatesEditComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() payrateevntchange: IsViewEditpayrate;
  @Output() IsViewEditpayrate = new EventEmitter<IsViewEditpayrate>();
  payrate: any = new EmployeePayrateBO();
  PayRateUnitList: any;
  disabledsavebutton:boolean=false;
  RateUnitList: [{ Key: string; Value: string }];
  ManagepayrateArray: any;
  deleteid: string;
  clientDropdown: any=[];
  serviceList:any=[]
  masterservice: any;
  decimalFormControl:FormControl;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    // disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true,
  };
  constructor(public global: GlobalComponent,public datepipe:DatePipe, public toastrService:ToastrService,private employeeService: EmployeeService,) {
    this.global.checkforlogout();
    this.decimalFormControl = new FormControl('', [
      Validators.pattern('[0-9]+(\.[0-9]+)?')
    ]);
  }
  ngOnInit(): void {
    document.getElementById("modelopen").click();
   
    this.getClient();
    this.getServiceList();
    console.log("!this.payrateevntchange.isEditPayorrate",this.payrateevntchange.isEditPayorrate)
    if (!this.payrateevntchange.isEditPayorrate){
      this.payrateAllList();
    }
    else {
      setTimeout(a=>{
        this.updatePayRate();
      },1000)
     
    }
  }

  

  ngOnChange(){
    this.getClient;

  }
  numbersOnly(event) {
    if (!this.global.isdigit(event.key) && event.key != ".") {
      event.preventDefault();
     
    }
    // if (event.key == '.') {
    //   event.preventDefault();
    // }
  }
  keyPressForDecimal(event)
 {
  if (!this.global.isdigit(event.key) && event.key != ".") {
    event.preventDefault();
   
  } else {    
     const inputValue = event.target['value'];    
     const decimalIndex = inputValue.indexOf('.');     
     if (decimalIndex !== -1) {       
       const digitsAfterDecimal = inputValue.substring(decimalIndex + 1).length;
       if (digitsAfterDecimal >= 2 && event.key !== 'Backspace') {
         event.preventDefault();
       }
     }
  }
  
 }
 isTransPortation_Service:boolean=false;
 CheckTrans_Service(ServiceId,index) {
  console.log(ServiceId,"ServiceId");
  if(ServiceId != null && ServiceId != undefined) {
    let Service_data=this.serviceList.filter(a=>a.Key == ServiceId)[0].Value;
     console.log("Service_data",Service_data);
    // let splittedData=Service_data.split(",",2);
    // console.log("splittedData",splittedData);
    // console.log("splittedData[1].trim().toLowerCase()",splittedData[1].trim().toLowerCase())
    // if(splittedData[1].trim().toLowerCase() == "transportation") {
    //   this.isTransPortation_Service=true;
    //   this.payrateList[index].rate=null;
    // } else{
    //   this.isTransPortation_Service=false;
    // }
  } else if(ServiceId == '' || ServiceId == null) {
    this.payrateList[index].rate=null;
  }
 
 }
  // getservice() {
  //   this.employeeservice.getpayorservice().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     this.masterservice = data;

  //     this.masterservice.forEach(element => {
  //       element.Value = element.masterservice.toString();
  //       element.Key = element.id.toString();
  //     });

  //   })
  // }

  payrateList: any = [];
  payrateAllList() {
    this.payrateList = [];
    let ab = {
      clientId: null,
      startDate: null,
      endDate: null,
      rate: null,
      serviceId: null,
      isadded: false,
      employeeId:null,
      id:"00000000-0000-0000-0000-000000000000",
      agencyId:null
    };
    this.payrateList.push(ab);
  }
  updatePayRate() {
    this.payrateList=[];
    this.payrateevntchange.updatedata.startDate=( this.payrateevntchange.updatedata.startDate!=null&&  this.payrateevntchange.updatedata.startDate!=undefined&&  this.payrateevntchange.updatedata.startDate!='')?
    this.datepipe.transform( this.payrateevntchange.updatedata.startDate,"MM/dd/yyyy"):null
    this.payrateevntchange.updatedata.endDate=( this.payrateevntchange.updatedata.endDate!=null&&  this.payrateevntchange.updatedata.endDate
      !=undefined&&  this.payrateevntchange.updatedata.endDate!='')?
    this.datepipe.transform( this.payrateevntchange.updatedata.endDate,"MM/dd/yyyy"):null
   
    this.payrateList.push(this.payrateevntchange.updatedata);
    console.log("payrateList---",this.payrateList);
    setTimeout(() => {
      console.log("serviceList",this.serviceList);
      this.CheckTrans_Service(this.payrateevntchange.updatedata.serviceId,this.payrateevntchange.updatedata.index);
    }, 400);
  }
  closedeletepayrate() {
    document.getElementById("deletemanagepayratemodal").click();
  }
  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  clickAdd(index, val) {
   
      if((new Date(val.startDate) > new Date(val.endDate)) && (val.endDate!=null&&val.endDate!=undefined&&val.endDate!='')){
        if(val.endDate!=null&&val.endDate!=undefined&&val.endDate!=''){
        this.toastrService.error(
          "End date must be greater than start date",
          'Error');
        return;
        }
      }
      else{
        this.payrateList[index].isadded = true;

        let ab = {
          clientId: val.clientId,
          startDate: null,
          endDate: null,
          rate: null,
          serviceId: null,
          isadded: false,
          employeeId:null,
          id:"00000000-0000-0000-0000-000000000000",
          agencyId:null
        };
        this.payrateList.push(ab);
      }

    
    
  }

  clickDelete(index, val) {
    this.payrateList[index-1].isadded=false
    this.payrateList.splice(index, 1);
  }
  clearAll(index, val) {
    this.payrateList[index] = {
      clientId: val.clientId,
      startDate: null,
      endDate: null,
      rate: null,
      serviceId: null,
      isAdd: true,
    };
  }
  deletepayrae() {
    let params = new URLSearchParams();
    params.append("Id", this.deleteid.toString());
    this.employeeService.deletepayrate(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success('Employee payrate Deleted successfully', 'payrate Deleted');
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
      this.back();
    },

      (err: HttpErrorResponse) => {
        this.toastrService.error(
          err.error,
          'Error');
      })
  }

  getClient() {
    
    this.employeeService.getclient().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.clientDropdown=JSON.parse(data)

      // this.clientDropdown.forEach(ele => {
      //   ele.Key = ele.id.toString(),
      //     ele.Value = ele.clientName.toString()
      // })
  
    })
  }
  
  getServiceList() {
    
    this.employeeService.getServicedropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.serviceList=data
     

    })
  }

  
  savePayRate(savepayrate) {
    this.disabledsavebutton=true;
    
    let data = JSON.parse(JSON.stringify(savepayrate))
    let showerror=true
    data?.forEach(element => {
      if((element.startDate==null || element.startDate=='' || element.startDate==undefined)||
    
       (element.serviceId==null|| element.serviceId == undefined || element.serviceId=='')||
      (element.rate==null || element.rate== undefined || element.rate=='')){
        this.toastrService.error('Please Fill Mandatory fields')
        this.disabledsavebutton=false;
        showerror=false
      }
      else{
        showerror=true
      }
    });
    data?.forEach(element => {    
        if((new Date(element.startDate) > new Date(element.endDate)) && (element.endDate!=null&&element.endDate!=undefined&&element.endDate!='')){
        this.toastrService.error("End date must be greater than start date",
        'Error')
        this.disabledsavebutton=false;
        showerror=false
      }
      
    })
    data?.forEach((ele) => {
      ele.startDate = (ele.startDate != '' && ele.startDate != undefined && ele.startDate != null) ?
        this.global.getDateTimeString(ele.startDate) : null;
        ele.endDate = (ele.endDate != '' && ele.endDate != undefined && ele.endDate != null) ?
        this.global.getDateTimeString(ele.endDate) : null;
        ele.employeeId = this.payrateevntchange.employeeId
        ele.agencyId=this.global.globalAgencyId
    })
    if(showerror){
    if (!this.payrateevntchange.isEditPayorrate) {

      this.employeeService.SaveEmployeePayrate(data).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.disabledsavebutton=false;
        this.toastrService.success('Pay Rate Created successfully', 'Pay Rate Created');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        document.getElementById("modelopen").click();
        this.back()
      },
        (err: any) => {
          this.disabledsavebutton=false;
          this.toastrService.error(
            err,
            'Error');
        })
    }
    else {
      data.id=this.payrateevntchange.payrateId;
      this.employeeService.SaveEmployeePayrate(data).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.disabledsavebutton=false;
        this.toastrService.success('Pay Rate Updated successfully', 'Pay Rate Updated');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        document.getElementById("modelopen").click();
        this.back()
      },
        (err: any) => {
          this.disabledsavebutton=false;
          this.toastrService.error(
            err
      );
        })
    }
  }
  }

  back() {
    this.IsViewEditpayrate.emit({
      isView: true,
      isEdit: false,
      isEditPayorrate: false,
      employeeId: this.payrateevntchange.employeeId,
      payrateId: "00000000-0000-0000-0000-000000000000",
      payrate: this.payrateevntchange.payrate,
      payratetype: "",
      updatedata: [],
    });
  }

  onDateChangedStartDate(i, event: IMyDateModel) {
    this.payrateList[i].startDate = event.formatted;
  }
  payRateStartDate(i, event: IMyInputFieldChanged) {
    let value = event.value;
    if (value.length == 5 && value.substring(2, 3) != "/") {
      this.payrateList[i].startDate =
        value.substring(0, 2) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(4, 10);
    }
  }

  onDateChangedEndDate(i, event: IMyDateModel) {
    this.payrateList[i].endDate = event.formatted;
  }
  payRateEndDate(i, event: IMyInputFieldChanged) {
    let value = event.value;
    if (value.length == 5 && value.substring(2, 3) != "/") {
      this.payrateList[i].endDate =
        value.substring(0, 2) +
        "/" +
        value.substring(2, 4) +
        "/" +
        value.substring(4, 10);
    }
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}

